import { render, staticRenderFns } from "./ProfileKyc.vue?vue&type=template&id=75f932f3&scoped=true"
import script from "./ProfileKyc.vue?vue&type=script&lang=js"
export * from "./ProfileKyc.vue?vue&type=script&lang=js"
import style0 from "./ProfileKyc.vue?vue&type=style&index=0&id=75f932f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f932f3",
  null
  
)

export default component.exports